import 'focus-visible';
import { b as MenuItem$1 } from '../../reach-menu-button.esm-22bcdd5f.js';
import { themed } from '@indeed/ifl-css';
import { disabledStyles } from '../../utils/styled.js';
import 'react';
import '../../reach-popover.esm-c19739dd.js';
import 'react-dom';

const StyledMenuItem = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: ["disabled"],
  shouldForwardProp: prop => prop !== "disabled",
  target: "ehvvxyn0"
} : {
  styleProps: ["disabled"],
  shouldForwardProp: prop => prop !== "disabled",
  target: "ehvvxyn0",
  label: "StyledMenuItem"
})(() => ({
  position: "relative",
  cursor: "pointer",
  bg: "background.action",
  paddingInlineStart: 3,
  paddingInlineEnd: 3,
  paddingBlockStart: "sc3",
  paddingBlockEnd: "sc3",
  userSelect: "none",
  // Focus state using keyboard
  "[data-focus-visible-added] &[data-selected]": {
    bg: "background.action.weaker",
    boxShadow: "focus.inset"
  },
  // Hover state
  ":hover, &[data-selected]": {
    bg: "background.action.hover"
  },
  // Active state
  ":active": {
    bg: "background.action.active"
  },
  // Selected
  '&[data-has-selection="true"]': {
    bg: "background.action.weaker"
  }
}), disabledStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @deprecated The `Menu` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 */

// We need to make the following casting because of a TS error regarding using a declaration
// (MenuItemImplProps interface) from Reach that cannot be named.
const MenuItem = StyledMenuItem.withComponent(MenuItem$1, process.env.NODE_ENV === "production" ? {
  target: "ehvvxyn1"
} : {
  target: "ehvvxyn1",
  label: "MenuItem"
});
MenuItem.displayName = "MenuItem";

export { MenuItem, StyledMenuItem };
